import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-surface';
import '../../common/bn-icon';
import '../../common/bn-form-field';
import '../../common/bn-modal-button';
import '../../organizations/parts/farm-address';
import '../../organizations/parts/organization-ancestors-bread-crumbs';
import '../../work-order-locations/actions/location-reschedule-modal';
import '../../work-orders/props/work-order-count';
import '../../notes/site-notes';

class SchedulerLocation extends LitEntity {
  constructor() {
    super();
    this.locations = [];
  }

  static get properties() {
    return {
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      :host([selected]) bn-surface {
        --bn-surface-border-color: var(--blue-20);
      }
      bn-surface {
        display: flex;
        flex-direction: column;
        cursor: pointer;
      }
      .content {
        display: flex;
        align-items: center;
      }
      .order {
        font-size: 1.2em;
        padding: .2em .5em;
        margin-right: 1em;
        font-weight: bold;
        color: var(--white-base);
        background-color: var(--primary);
        border-radius: 1em;
        width: 1em;
        text-align: center;
      }
      .farm-icon {
        color: var(--primary);
        margin-right: 1rem;
        font-size: 1.5rem;
      }
      farm-address {
        color: var(--gray-80);
      }
      .count {
        display: flex;
        align-items: center;
        margin: 0 .5rem;
      }
      .reschedule {
        display: flex;
        align-items: center;
        margin: 0 .5rem;
      }
      .reschedule bn-icon {
        margin-right: .5em;
      }
      .handle {
        cursor: grab;
        background-color: var(--blue-40);
        display: flex;
        align-items: center;
        color: var(--blue-60);
        border-radius: 4px;
        padding: 1rem;
        margin-left: .5rem;
      }
      bn-map-marker {
        height: 1.5em;
        width: 1em;
        margin: 0 .5em 0 0;
      }
      .map-marker-icon {
        margin: 0 .5em 0 0;
        height: 1.75em;
      }
      @media(max-width: 800px) {
        .content {
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
        }
        .order {
          margin: 0;
          order: 2;
        }
        .farm-icon {
          order: 1;
          margin: 0;
        }
        .count {
          order: 3;
          margin: 0;
        }
        .farm-name {
          margin-top: 1rem;
          order: 4;
          width: 100%;
        }
        .reschedule {
          width: 100%;
          order: 5;
          display: flex;
          justify-content: center;
          margin: 1rem 0 0 0;
        }
        .handle {
          display: none;
        }
      }
    `];
  }

  render() {
    const farmHref = this.getHref('https://api.binsentry.com/rel/farm');
    return html`
      <bn-surface>
        <div class="content">
          <div class="order">
            ${this.getProperty('order', '')}
          </div>

          <div class="farm-icon">
            <bn-icon name="fad fa-farm"></bn-icon>
          </div>

          <div class="farm-name">
            <organization-ancestors-bread-crumbs
              .href="${farmHref}"
              ancestorMinIndex="0"
              stop-at-type="binsentry"
            ></organization-ancestors-bread-crumbs>

            <farm-address .href="${farmHref}"></farm-address>
          </div>

          <div class="count">
            <img class="map-marker-icon" src="/images/map_marker_binsentry_blue.png"/>
            ${this.getProperty('workOrderCount')}
          </div>

          <div class="reschedule">
            <bn-modal-button button-class="button--outlined">
              <span slot="text">
                <bn-icon name="far fa-calendar-edit"></bn-icon>
                Reschedule
              </span>
              <location-reschedule-modal
                slot="modal"
                .href="${this.href}"
                @response="${this._reload}"
              ></location-reschedule-modal>
            </bn-modal-button>
          </div>

          <div class="handle">
            <bn-icon class="drag-indicator" name="far fa-ellipsis-v"></bn-icon>
            <bn-icon class="drag-indicator" name="far fa-ellipsis-v"></bn-icon>
          </div>
        </div>
        <site-notes href="${farmHref}" readonly></site-notes>
      </bn-surface>
    `;
  }

  _reload(e) {
    this.dispatchEvent(new CustomEvent('response'), { detail: e.detail, bubbles: true, composed: true });
  }

  _renderLocation(location) {
    return html`
      ${this.getProperty('address', location)}
    `;
  }
}

customElements.define('scheduler-location', SchedulerLocation);
